import { OptionDefinition, OptionGroup } from './interfaces';

const defaultOptionDescription = (
  option: OptionDefinition,
  parentGroup?: OptionGroup,
  selected?: boolean,
  selectedAriaLabel?: string
): string => {
  const messageParts = [
    parentGroup && parentGroup.label,
    option.value,
    option.label,
    option.description,
    option.labelTag,
    ...(option.tags || []),
    selected ? selectedAriaLabel : null,
  ].filter(el => !!el);

  return messageParts.join(' ');
};

export default defaultOptionDescription;
